import { Table } from "antd";
import "./table.scss";

export default function AntTable({
  tableHeader,
  tableColumns,
  tableData,
  rowData,
  isLoading,
  hideArrowExpand,
  setPage,
  page,
  selectionType,
  total,
  expandRowByClick = true,
  onRow,
  selectedRowKeys,
  setSelectedRowKeys,
}: {
  tableHeader?: any;
  tableColumns: any;
  rowData?: any;
  isLoading: boolean;
  hideArrowExpand?: boolean;
  tableData: any;
  total?: any;
  setPage?: any;
  selectedRowKeys?: any;
  setSelectedRowKeys?: any;
  page?: any;
  selectionType?: any;
  expandRowByClick?: boolean;
  onRow?: any;
}) {
  const rowSelection: any = selectedRowKeys
    ? {
        onChange: (selectedRowKeys: any, selectedRows: any) => {
          console.log("Selected Row IDs:", selectedRowKeys); // Logging the selected row IDs
          setSelectedRowKeys(selectedRowKeys);
        },
        getCheckboxProps: (record: any) => ({
          // Disable checkbox if the row doesn't contain a specific key
          disabled: !selectedRowKeys, // Replace 'yourSpecificKey' with the actual key you're checking
        }),
        selectedRowKeys, // this property ensures the selected rows are controlled by the state
        type: selectionType, // you can set this to 'checkbox' or 'radio'
      }
    : false;
  return (
    <div className="global-table-wrapper max-lg:overflow-auto">
      <div className="table-header-holder">{tableHeader}</div>
      <div className="table-body-holder">
        <Table
          columns={tableColumns || []}
          dataSource={tableData}
          loading={isLoading}
          pagination={{
            hideOnSinglePage: true,
            showSizeChanger: false,
            pageSize: 15,
            total,
            current: page,
            defaultCurrent: 1,
            onChange: (current, size) => {
              setPage(current);
            },
          }}
          rowSelection={rowSelection}
          expandable={{
            expandRowByClick: expandRowByClick,
            expandIconColumnIndex: -1,
            // fixed: "right",
            // expandIcon: ({ expanded }) =>
            //   expanded ? (
            //     <MdKeyboardArrowDown size={22} />
            //   ) : (
            //     <MdKeyboardArrowUp size={22} />
            //   ),
            expandedRowRender: (record: any) =>
              rowData ? rowData(record) : null,
          }}
          onRow={onRow}
          rowKey="id"
          // scroll={{ y: 240 }}
        />
      </div>
    </div>
  );
}
